import LoginApp from './LoginApp';

export default LoginApp;
